const getGlobal = (): any => (typeof window !== 'undefined' ? window : global);

const getTinyMce = (): any => {
  const global = getGlobal();

  return global && global.tinymce ? global.tinymce : null;
};

export default getTinyMce;
